import {
  multiEmail,
  multiEmailError,
  multiEmailIsFocused,
  multiEmailLabel,
  multiEmailWithError,
} from '../multi-email/multi-email.css.ts';
import { themeVars } from '../theme/vars.ts';
import { space } from '../tokens.ts';
import { typography } from '../typography.ts';
import { style } from '../layer.css';

export const multiTag = style([
  multiEmail,
  {
    selectors: {
      '&:is(&)': {
        height: 'auto',
      },
    },
  },
]);

export const multiTagIsFocused = style([multiEmailIsFocused]);
export const multiTagWithError = style([multiEmailWithError]);

export const multiTagLabel = style([multiEmailLabel]);
export const multiTagError = style([multiEmailError]);

export const multiTagBottomTip = style([
  typography.bodySm,
  {
    marginTop: space.s4,
    color: themeVars.container.foreground.tertiary,
  },
]);

export const tagItem = style([
  typography.bodyMd,
  {
    display: 'flex',
    alignItems: 'center',
    gap: space.s4,
  },
]);
